module.exports = __webpack_public_path__ + "fonts/MADETommySoftBoldPERSONALUSE.70836940.ttf";